function run(context) {
  var el = context.querySelector('.click-to-call-preferences');
  if (!el) {
    return;
  }

  require.ensure('../modules/click_to_call_preferences', function(require) {
    var ClickToCallPreferences = require('../modules/click_to_call_preferences');
    return new ClickToCallPreferences(el);
  });
}

run(document);

$('html').on('loaded:dialog.nearme', function() {
  run(document.querySelector('.dialog'));
});



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/click_to_call.initializer.js